import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import './_InputValidationView.scss';

const { Places } = Tooltip;

/**
 * @class InputValidationView
 **/
export default class InputValidationView extends PureComponent {
  renderPopover() {
    const { message, children, className, popoverContainer, typeProps, messageProps } = this.props;
    const containerClasses = classnames(
      'InputValidationView',
      'InputValidationView--popover',
      className
    );

    const hasMessage = !!message;
    const content = hasMessage ? (
      <span {...messageProps} className="InputValidationView__validation-message">
        {message}
      </span>
    ) : (
      ''
    );

    return (
      <div className={containerClasses}>
        <Tooltip
          container={popoverContainer}
          {...typeProps}
          content={content}
          show={hasMessage}
          place={Places.BOTTOM}
        >
          {children}
        </Tooltip>
      </div>
    );
  }

  renderSubtitle() {
    const { message, messageProps, children, style, className, typeProps } = this.props;
    const containerClasses = classnames(
      'InputValidationView',
      'InputValidationView--subtitle',
      className
    );

    return (
      <div {...typeProps} className={containerClasses} style={style}>
        {children}
        {message && (
          <span {...messageProps} className="InputValidationView__validation-message">
            {message}
          </span>
        )}
      </div>
    );
  }

  /**
   * Render
   * @returns {VDOM}
   **/
  render() {
    if (
      !objectValues(InputValidationView.Types).includes(this.props.type) ||
      typeof this[`render${this.props.type}`] !== 'function'
    ) {
      console.error(
        `Wrong ValidationView Type passed, should be of type ${Object.keys(
          InputValidationView.Types
        )
          .map(t => `InputValidationView.Types.${t}`)
          .join(', ')}`
      );
      return null;
    }
    return this[`render${this.props.type}`]();
  }
}

InputValidationView.Types = {
  POPOVER: 'Popover',
  SUBTITLE: 'Subtitle'
};

InputValidationView.defaultProps = {
  type: InputValidationView.Types.SUBTITLE
};

InputValidationView.propTypes = {
  /**
   * Content of the input validation view
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /**
   * A message indicating error text to show. If not empty - field is invalid.
   */
  message: PropTypes.string,
  /**
   * An object containing attributes to be spread on the validation span element
   */
  messageProps: PropTypes.object,
  /**
   * The type of validation to display, the possible values are InputValidationView.Types.POPOVER, InputValidationView.Types.SUBTITLE
   */
  type: PropTypes.oneOf(objectValues(InputValidationView.Types)),
  /**
   * ClassName to apply on the container
   */
  className: PropTypes.string,
  /**
   * Style to apply on the container
   */
  style: PropTypes.object,
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Tooltip appended to it.
   */
  popoverContainer: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  /**
   * Validation type props. Spreads the props on the validation component.
   */
  typeProps: PropTypes.object
};
